import React from "react";

// // // //

/**
 * WebsiteJsonLd
 * Add WebSite JSON-LD structured data to the <head> of the HTML document.
 * This tells search engines about the site's search functionality, enabling
 * Google to show a sitelinks search box in search results.
 *
 * NOTE: We built our own component because the next-seo package doesn't
 * include a primitive for WebSite schema with SearchAction.
 *
 * @see https://schema.org/WebSite
 * @see https://schema.org/SearchAction
 * @see https://developers.google.com/search/docs/appearance/structured-data/sitelinks-searchbox
 */
export function WebsiteJsonLd() {
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "RWA.xyz",
        url: "https://app.rwa.xyz",
        potentialAction: {
            "@type": "SearchAction",
            target: {
                "@type": "EntryPoint",
                urlTemplate:
                    "https://app.rwa.xyz/search?query={search_term_string}",
            },
            "query-input": "required name=search_term_string",
        },
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
    );
}
